module.exports = __webpack_public_path__ + "img/With Redtea-.96d9fe32.png";